/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Category from 'linced-admin/models/goals/category';
import type Subcategory from 'linced-admin/models/goals/subcategory';
import type Subject from 'linced-admin/models/goals/subject';
import type Person from 'linced-admin/models/person';
import type School from 'linced-admin/models/school';

// Proto: goals.GoalTemplate.
export default class Goal extends Model {
  declare [Type]: 'goals/goal';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string')
  declare campusId: string | undefined; // TODO: implement when we have Campuses

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare subjectId: AsyncBelongsTo<Subject>;

  @alias('subjectId')
  declare subject: AsyncBelongsTo<Subject>;

  @attr('boolean', { defaultValue: false })
  declare isPLP: boolean;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @belongsTo('goals/category', { async: true, inverse: 'goals' })
  declare categoryId: AsyncBelongsTo<Category>;

  @alias('categoryId')
  declare category: AsyncBelongsTo<Category>;

  @belongsTo('goals/subcategory', { async: true, inverse: 'goals' })
  declare subcategoryId: AsyncBelongsTo<Subcategory>;

  @alias('subcategoryId')
  declare subcategory: AsyncBelongsTo<Subcategory>;

  // subcategory_id flattens the async relationship's id into a single-level
  // key. Array macros such as `filterBy` can only expand `@each` one level
  // deep, so they must depend on this rather than on `subcategory.id`.
  @alias('subcategory.id')
  declare subcategory_id: string | null | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('string')
  declare templateId: string | undefined; // TODO: implement once Templates are added

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @hasMany('goals/goal', { async: true, inverse: null })
  declare linkedGoalIds: AsyncHasMany<Goal>;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare educatorDescription: string;

  @attr('string', { defaultValue: '' })
  declare peopleDescription: string;

  @attr('string', { defaultValue: '' })
  declare exemplar: string;

  @attr('string', { defaultValue: '' })
  declare learningPurpose: string;

  @attr('string', { defaultValue: '' })
  declare learningIntentions: string;

  @attr('string', { defaultValue: '' })
  declare successCriteria: string;

  @attr('string', { defaultValue: '' })
  declare keyQuestions: string;

  @attr('string', { defaultValue: '' })
  declare learningConnections: string;

  @attr('string', { defaultValue: '' })
  declare assessmentTasks: string;

  @attr('string', { defaultValue: '' })
  declare teachingStrategies: string;

  @attr('string', { defaultValue: '' })
  declare SC1: string;

  @attr('string', { defaultValue: '' })
  declare SC2: string;

  @attr('string', { defaultValue: '' })
  declare SC3: string;

  @attr('string', { defaultValue: '' })
  declare SC4: string;

  @attr('string', { defaultValue: '' })
  declare SC5: string;
}
